import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { refeshPend } from "../../../App";
import { getApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import "../../Tabs/tabs.css";

function PendingManifest() {
    const { ref } = useContext(refeshPend)
    const [getManifest, setGetManifest] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const [formDate, setFormDate] = useState({
        fromDate: firstDayOfMonth,
        toDate: today,
    });

    const handleDateChange = (date, field) => {
        setFormDate({ ...formDate, [field]: date });
        setCurrentPage(1);
    };
   const fetchData = async () => {
    setLoading(true);
    try {
        const login = JSON.parse(localStorage.getItem("Login"));
        const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // ✅ SAFE
};

        const response = await getApi(
            `/Manifest/getPendingManifest?DocketNo=${searchQuery}&branchCode=${login?.Branch_Code}&pageNumber=${currentPage}&pageSize=${rowsPerPage}&FromDate=${formatDate(formDate.fromDate)}&ToDate=${formatDate(formDate.toDate)}`
        );

        const currentPageData = response?.Data || [];

        setGetManifest(currentPageData);

        // ✅ USE BACKEND COUNT
        setTotalRecords(response?.totalCount || 0);

    } catch (error) {
        console.error("Error fetching data:", error);
    } finally {
        setLoading(false);
    }
};
    useEffect(() => {
        fetchData();
    }, [currentPage, rowsPerPage, ref,formDate,searchQuery]);
   
    const refreshPendingData = async () => {
        await fetchData(); // your existing fetch function
    };
    // -------------------- END FIX --------------------

    console.log(getManifest);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const totalPages = Math.max(1, Math.ceil(totalRecords / rowsPerPage));

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    return (
        <div className="body">
            <div className="container1" >
                
                <div className="addNew" style={{ whiteSpace:"nowrap"}}>
                    <div className="dropdown">
                        <button className="dropbtn">
                            <i className="bi bi-file-earmark-arrow-down"></i> Export
                        </button>
                        <div className="dropdown-content">
                            <button>Export to Excel</button>
                            <button>Export to PDF</button>
                        </div>
                    </div>
                    
                    <div className="custom-field">
                
                    <div className="custom-date input-field">
                        <label >From Date</label>
                        <DatePicker
                            portalId="root-portal"
                            selected={formDate.fromDate}
                            onChange={(date) => handleDateChange(date, "fromDate")}
                            dateFormat="dd/MM/yyyy"
                           
                        />
                    </div>

                    <div className="custom-date input-field" >
                        <label >To Date</label>
                        <DatePicker
                            portalId="root-portal"
                            selected={formDate.toDate}
                            onChange={(date) => handleDateChange(date, "toDate")}
                            dateFormat="dd/MM/yyyy"
                            
                        />
                    </div>

                    </div>

                    <div className="search-input">
                        <input
                            className="add-input1"
                            type="text"
                            placeholder="search"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginLeft: "0%" }}
                        />
                        <button type="submit" title="search">
                            <i className="bi bi-search"></i>
                        </button>
                    </div>
                
                </div>

                <div className="table-container">
                    <table className="table table-bordered table-sm" style={{whiteSpace:"nowrap"}}>
                        <thead className="table-sm">
                            <tr>
                                    <th className="w-60">Sr.No</th>
                                    <th>Branch.Code</th>
                                    <th>Branch.Name</th>
                                    <th>Docket.No</th>
                                    <th>Date</th>
                                    <th>Client Name</th>
                                    <th>Receiver</th>
                                    <th>From City</th>
                                    <th>To City</th>
                                    <th>Qty</th>
                                    <th>Weight</th>
                                    <th>Invoice.No</th>
                                    <th>Invoice.Value</th>
                                    <th>E-Way.Bill.No</th>
                                </tr>
                        </thead>
                        <tbody>
                            {
                            getManifest.map((manifest, index) => (
                                 <tr key={index}>
                                        <td className="w-60">{index + 1}</td>
                                        <td>{manifest.Branch_code}</td>
                                        <td>{manifest.Branch_Name}</td>
                                        <td>{manifest.DocketNo}</td>
                                        <td>{manifest.BookDate}</td>
                                        <td>{manifest.customerName}</td>
                                        <td>{manifest.consigneeName}</td>
                                        <td>{manifest.fromDest}</td>
                                        <td>{manifest.toDest}</td>
                                        <td>{manifest.pcs}</td>
                                        <td>{manifest.actualWt}</td>
                                        <td>{manifest.invoiceNo}</td>
                                        <td>{manifest.invoiceValue}</td>
                                        <td>{manifest.eWayBillNo}</td>
                                    </tr>

                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="row" style={{ whiteSpace: "nowrap" }}>
            <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
              <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                {'<'}
              </button>
              <span style={{ color: "#333", padding: "5px" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                {'>'}
              </button>
            </div>

            <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
              <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}

                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
              >
                <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
              </select>
            </div>
          </div>
            </div>
        </div>
    );
}

export default PendingManifest;
